/* Сохраняем query параметры для miniapps, если они есть в url */
export default defineNuxtRouteMiddleware((to, from) => {
  const telegramChatId = from.query.telegram_chat_id

  // если в предыдущем урле был test и сейчас его нет — добавляем
  if (telegramChatId && !to.query.telegram_chat_id) {
    return navigateTo({
      path: to.path,
      query: {
        ...to.query,
        telegram_chat_id: telegramChatId,
      },
    })
  }

  const vkUserId = from.query.vk_user_id

  if (vkUserId && !to.query.vk_user_id) {
    return navigateTo({
      path: to.path,
      query: {
        ...to.query,
        vk_user_id: vkUserId,
      },
    })
  }
})
